/* global ga */

const initGoogleTagManager = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.allowlist': ['google'],
    'gtm.blocklist': ['opt', 'ts', 'gclidw', 'awct', 'sp'],
  });

  /*  eslint-disable */
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l != 'dataLayer' ? `&l=${l}` : '';

    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  })(
    window,
    document,
    'script',
    'dataLayer',
    window.__CLIENT_TRACKING__.googleTagManagerId,
  );
  /*  eslint-enable */
};

const initGoogleAnalytics = () => {
  if (!window.ga && window.__CLIENT_TRACKING__.trackingId) {
    /* eslint-disable */
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      (i[r] =
        i[r] ||
        function () {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      'script',
      'https://www.google-analytics.com/analytics.js',
      'ga',
    );
  }
  /*  eslint-enable */

  if (window.__CLIENT_TRACKING__.trackingId) {
    ga('create', window.__CLIENT_TRACKING__.trackingId, 'auto');
    ga('send', 'pageview');
  }
};

export const initGoogle = () => {
  if (window.__CLIENT_TRACKING__.googleTagManagerId) {
    return initGoogleTagManager();
  }

  initGoogleAnalytics();
};
